import { cn } from '@commenda/utils';
import type { ComponentProps } from 'react';

type OlProps = ComponentProps<'ol'> & { node?: unknown };

export function MarkdownOrderedList({
  node: _node,
  className,
  ...rest
}: OlProps) {
  return (
    <ol
      className={cn(
        'my-3 list-outside list-decimal space-y-1.5 pl-6 [&>li>p]:my-0',
        className
      )}
      {...rest}
    />
  );
}

type UlProps = ComponentProps<'ul'> & { node?: unknown };

export function MarkdownUnorderedList({
  node: _node,
  className,
  ...rest
}: UlProps) {
  return (
    <ul
      className={cn(
        'my-3 list-outside list-disc space-y-1.5 pl-6 [&>li>p]:my-0',
        className
      )}
      {...rest}
    />
  );
}

type LiProps = ComponentProps<'li'> & { node?: unknown };

export function MarkdownListItem({ node: _node, className, ...rest }: LiProps) {
  return <li className={cn('pl-1.5', className)} {...rest} />;
}
